<template>
  <div>
    <transition name="fade">
      <v-progress-linear
        v-if="isLoading"
        color="primary"
        class="pa-0 ma-0"
        height="3"
        indeterminate
      />
    </transition>
  </div>
</template>

<script>
import requestStatusMixin from 'mixins/requestStatus'
import { createHideLink, catchError } from 'corp-front-vue-commons/src/utils/functions'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'CheckLinkPage',
  mixins: [requestStatusMixin],
  computed: {
    routeQueryParams () {
      return this.$route.query
    }
  },
  methods: {
    redirectToRoute (name) {
      this.$router.push({ name }).catch(() => {})
    },

    async downloadDocument () {
      try {
        const { document = null, token = null } = this.routeQueryParams

        if (!document || !token) return

        const url = `${process.env.VUE_APP_API_URL}/b2b-document-app/download`
        const config = {
          method: 'GET',
          headers: { Authorization: token }
        }

        const res = await fetch(`${url}?document=${document}`, config)
        return res.json()
      } catch (error) {
        catchError(error)
        return null
      }
    },

    async getS3LinkDocument () {
      this.setStatus(STATUS_IS_LOADING)

      try {
        const res = await this.downloadDocument()

        if (!res || !res.valid) {
          return this.redirectToRoute('ExpiredLink')
        }

        createHideLink(res.content)
        this.setStatus(STATUS_SUCCESS)
        setTimeout(() => this.redirectToRoute('Home'), 1000)
      } catch (error) {
        this.redirectToRoute('ExpiredLink')
        this.setStatus(STATUS_FAILED)
        catchError(error)
      }
    }
  },
  mounted () {
    this.getS3LinkDocument()
  }
}
</script>
